<template>
  <div>
    <div class="flex justify-center">
      <div class="bg-cecbcb p-2 rounded-full">
        <feather-icon icon="CheckIcon" svgClasses="w-20 h-20" />
      </div>
    </div>
    <div class="pt-5">
      <h2 class="text-center fsize25 font-bold text-black">
        Thanks for registering for Beta Access!
      </h2>
      <p class="text-center text-black pt-3">
        You're in for early access of our app and exclusive insights. We
        appreciate your support in making caregiving better for everyone!
      </p>
    </div>
  </div>
</template>

<script>
import FeatherIcon from "../../../components/FeatherIcon.vue";
export default {};
</script>

<style>
.bg-cecbcb {
  background: #cecbcb !important;
}
</style>

FeatherIcon
